import { ClipboardIcon } from "@radix-ui/react-icons";
import { toast } from "sonner";

import { cn } from "@/utils";

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "./ui/tooltip";

export type ClipboardButtonProps = {
  text: string;
  className?: string;
};

export function ClipboardButton({ text, className }: ClipboardButtonProps) {
  return (
    <TooltipProvider delayDuration={0}>
      <Tooltip>
        <TooltipTrigger>
          <button
            type="button"
            className={cn(
              "rounded-lg border bg-background p-1 hover:bg-muted",
              className,
            )}
            onClick={async () => {
              try {
                await navigator.clipboard.writeText(text);

                toast.success("Sucesso", {
                  description: "Copiado para a área de transferência",
                });
              } catch (e) {
                toast.error("Erro", {
                  description:
                    "Não foi possível copiar para a área de transferência",
                });
              }
            }}
          >
            <ClipboardIcon className="h-3 w-3" />
          </button>
        </TooltipTrigger>

        <TooltipContent>Copiar para a área de transferência</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
